import { apiUpload } from './http';

export type WebUpload = {
  platform: 'web';
  file: Blob;
};

export type UploadPayload = WebUpload;

export function asWebUpload(file: Blob): WebUpload {
  return { platform: 'web', file };
}

function toBlob(payload: UploadPayload | Blob): Blob {
  return 'platform' in payload ? payload.file : payload;
}

function payloadFilename(payload: UploadPayload | Blob): string | undefined {
  const blob = toBlob(payload);
  return (blob as File).name || undefined;
}

/** Upload a block image or PDF. Returns the storage path assigned by the server. */
export async function uploadBlockFile(payload: UploadPayload | Blob, filename?: string): Promise<string> {
  const { path } = await apiUpload<{ path: string }>(
    '/api/blocks/upload',
    toBlob(payload),
    filename || payloadFilename(payload),
  );
  return path;
}

/** Upload an avatar image. Returns the storage path assigned by the server. */
export async function uploadAvatarFile(payload: UploadPayload | Blob, filename?: string): Promise<string> {
  const { path } = await apiUpload<{ path: string }>(
    '/api/profiles/avatar',
    toBlob(payload),
    filename || payloadFilename(payload),
  );
  return path;
}
